import { render, staticRenderFns } from "./rapidActuarial.vue?vue&type=template&id=680ef021&scoped=true"
import script from "./rapidActuarial.vue?vue&type=script&lang=js"
export * from "./rapidActuarial.vue?vue&type=script&lang=js"
import style0 from "./rapidActuarial.vue?vue&type=style&index=0&id=680ef021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ef021",
  null
  
)

export default component.exports